import { Subscription } from 'rxjs';
import { DataTransferService } from 'libs/shared/src/lib/service/data-transfer.service';
import { StorageService } from 'libs/base/src/lib/services/storage.service';
import { NgModule, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core'
import { build } from 'apps/ubivu-panel/src/environments/build';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', `.json?v=${build.VERSION}/${build.SUB_VERSION}`);
}

const translationOptions = {
  loader: {
    provide: TranslateLoader,
    useFactory: (createTranslateLoader),
    deps: [HttpClient],
  },
};

@NgModule({
  imports: [TranslateModule.forRoot(translationOptions)],
  exports: [TranslateModule],
})
export class AppTranslationModule implements OnDestroy {
  loginSuccessSub: Subscription;
  constructor(private translate: TranslateService,
    private storageService: StorageService,
    private dataTransferService: DataTransferService) {
    translate.addLangs(['en, es, kz, ch, pt']);
    const lang = this.storageService.getStorageItem('lang');
    const defaultLang = 'en';
    if (lang) {
      translate.setDefaultLang(lang);
      translate.use(lang);
    } else {
      translate.setDefaultLang(defaultLang);
      translate.use(defaultLang);
    }

    this.loginSuccessSub = this.dataTransferService.subscribe('loginSuccess', (res) => {
      if (res) {
        const lang = this.storageService.getStorageItem('lang');
         if(lang){
          this.translate.setDefaultLang(lang);
          this.translate.use(lang);
         } else {
          this.storageService.store('lang', defaultLang);
          this.translate.setDefaultLang(defaultLang);
          this.translate.use(defaultLang);
         }    
      }
    });
  }

  ngOnDestroy() {
    if (this.loginSuccessSub) {
      this.loginSuccessSub.unsubscribe();
    }
  }
}
